var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-0",attrs:{"id":"buttonrow"}},[_c('v-btn',{staticClass:"mx-1",attrs:{"color":"primary","id":"export-png"},on:{"click":function($event){return _vm.exportAllPng()}}},[_vm._v("匯出所有圖表")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }